import React, { Suspense, startTransition, useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import img3 from "../Assets/dmhb (1).png";
import img4 from "../Assets/dmhb (2).png";
import img5 from "../Assets/Kolkata.png";
import img6 from "../Assets/Chennai.png";
import Footer from "../Components/Footer";
import logogif from "../Assets/logogif-optimized.webp";
import Aos from "aos";
import "aos/dist/aos.css";
import "animate.css";
import NewWhy from "../Components/NewWhy.jsx";
import NewServices from "../Components/NewServices.jsx";
import Slider from "../Components/Slider.jsx";
import coming from "../Assets/Comming.png";
import axios from "axios";
import { API_URI } from "../Common/data";
import { Link, useNavigate } from "react-router-dom";
import HowPvt from "./HowPvt.jsx";
import CircleImg from "../Components/CircleImg.jsx";
import { Helmet } from "react-helmet";
import KeywordFooterSection from "./KeywordFooterSection.jsx";
import HomeFAQ from "./HomeFAQ.jsx";
import { toBlogPreview } from "../Common/blogPreview";

const Wave = React.lazy(() => import("../Components/Wave"));

function Home() {
  const [seo, setSeo] = useState({
    title: "Best Birthday Celebration Place in Laxmi Nagar",
    metaDescription:
      "Make your special day unforgettable at the best birthday celebration place in Laxmi Nagar! Our stylish and spacious venue is perfect for kids, teens, and adults. Enjoy customized décor, catering, music, and more — all under one roof",
    metaKeywords: "",
    ogImage: "",
    ogTitle: "Best Birthday Celebration Place in Laxmi Nagar",
    ogDescription:
      "Make your special day unforgettable at the best birthday celebration place in Laxmi Nagar! Our stylish and spacious venue is perfect for kids, teens, and adults. Enjoy customized décor, catering, music, and more — all under one roof",
    canonicalUrl: "",
  });

  useEffect(() => {
    axios.get(`${API_URI}/page-seo/home`).then((res) => {
      if (res.data && res.data.data) setSeo(res.data.data);
    });
  }, []);

  useEffect(() => {
    Aos.init();
  }, []);
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(`${API_URI}/blog/all`); // Adjust API path
        if (response.status === 200) {
          const previewBlogs = (response?.data?.data || [])
            .map((blog) => toBlogPreview(blog))
            .slice(0, 3);
          startTransition(() => {
            setBlogs(previewBlogs);
          });
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    };

    fetchBlogs();
  }, []);
  return (
    <>
      <Helmet>
        <title>
          {" "}
          {seo.metaTitle && seo.metaTitle.toLowerCase() !== "test title"
            ? seo.metaTitle
            : "Cine Celebrate - Home"}
        </title>
        <meta
          name="title"
          content={
            seo.metaTitle && seo.metaTitle.toLowerCase() !== "test title"
              ? seo.metaTitle
              : "Cine Celebrate - Home"
          }
        />
        <meta
          name="description"
          content={
            seo.metaDescription &&
            seo.metaDescription.toLowerCase() !== "test description"
              ? seo.metaDescription
              : "Cine Celebrate - Home"
          }
        />
        <meta
          name="keywords"
          content={
            seo?.metaKeywords && Array.isArray(seo?.metaKeywords)
              ? seo?.metaKeywords.join(", ")
              : "Private Theater, Celebration, Cine Celebrate"
          }
        />
        <link rel="canonical" href={seo?.canonicalUrl} />
        <meta property="og:title" content={seo?.ogTitle} />
        <meta property="og:description" content={seo?.ogDescription} />
        <meta property="og:image" content={seo?.ogImage} />
      </Helmet>
      <div className="smooth-scroll home-page--jet">
        <Navbar />
        <Slider />
        {/* <CurveSlider/> */}
        {/* <Amination/> */}
        {/* <div className="updated-banner"> */}
        {/* <div className="marquee-container">
    <div className="marquee">
      <span>CINE CELEBRATE</span>
      <span>CINE CELEBRATE</span>
      <span>CINE CELEBRATE</span>
      <span>CINE CELEBRATE</span>
      <span>CINE CELEBRATE</span>
      <span>CINE CELEBRATE</span>
      <span>CINE CELEBRATE</span>
      <span>CINE CELEBRATE</span>
      <span>CINE CELEBRATE</span>

    
    </div>
  </div> */}
        {/* {images.length > 0 && (
        <img
          src={images[imageIndex]}
          alt="Sliding Image"
          style={{ transform, transition: "transform 0.2s ease" }}
          onMouseMove={handleMove}
          onMouseLeave={resetTransform}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          className="tilt-card"
        />
      )} */}

        {/* <img src={newim}/> */}

        {/* </div> */}
        {/* <div className="banner">
          <h2 data-aos="zoom-in" data-aos-duration="2000">
            Cine Celebrate
          </h2>
          <h3 data-aos="fade-down" data-aos-duration="2000">
            The World’s Most
            <br /> Megical Celebration{" "}
          </h3>
          <br />
          <br />
          <button>Book Now</button>
        </div> */}
        <br />
        <NewWhy />
        <Suspense fallback={null}>
          <Wave />
        </Suspense>
        <NewServices />
        {/* <img className="g1" src={g1} /> */}
        <div className="about-home">
          <div className="about-home-left">
            <p>About Us</p>
            <h2>Cine Celebrate – Best Private theater in Laxmi Nagar</h2>
            <h4>
              {/* The Cine Celebrate brings you a revolutionary way to celebrate
              with Private Theatre Celebrations. Whether it's a birthday,
              anniversary, date night, or a "bride-to-be" bash, our private
              theaters offer the perfect venue to create unforgettable moments.
              Enjoy your favorite movies, shows, photos, or videos on the big
              screen with your loved ones. Enhance the experience with add-ons
              like photoshoots, and more. At The Cine Celebrate, we make
              celebrations easy, affordable, and truly memorable. Transform your
              special occasions into cinematic experiences you’ll cherish
              forever! */}
              At Cine Celebrate, we’ve created a space where celebrations feel
              more personal and truly memorable. Located in Laxmi Nagar, Delhi,
              our private theater offers a refreshing alternative to typical
              party venues. Instead of booking a crowded banquet hall, many
              people now prefer a private theater in Delhi where they can enjoy
              the big screen experience with complete privacy and comfort.
              {/* At Cine Celebrate, we redefine how special moments are
              cherished—with an exclusive private theater experience that turns
              everyday celebrations into cinematic memories. Whether you're
              planning a birthday party, anniversary surprise, romantic movie
              date, bride-to-be bash, baby shower, or even a mini seminar or
              gathering, our private screening rooms are designed to give you
              complete privacy, comfort, and joy. Think beyond traditional
              venues—here, your favorite movie or memory plays on the big
              screen, just for you and your guests. */}
              <br />
              <br />
              Our private screening rooms are used for birthday parties,
              anniversary surprises, romantic movie dates, bride-to-be bashes,
              baby showers, and even small seminars or close gatherings. If
              you’re searching for a private cinema in Delhi NCR, especially
              around Laxmi Nagar, this is where your favourite movie, proposal
              video, or personal memories can be played exclusively for you and
              your guests.
              {/* Each celebration is personalized with thoughtful add-ons like
              balloon decorations, themed setups, professional photoshoots, LED
              displays, custom messages, and food packages curated to elevate
              the moment. We offer dedicated support to help you plan
              effortlessly, while our seamless booking process lets you choose
              your preferred slot, theme, and add-ons all in one place. */}
              <br />
              <br />
              What makes the experience even better is the flexibility. You can
              choose balloon decorations, themed setups, professional
              photoshoots, LED displays, custom on-screen messages, and curated
              food packages based on your celebration style. As one of the
              decorated private venues in Delhi NCR, we focus on keeping
              everything simple and well-organised. From selecting your
              preferred slot to finalising add-ons, our team provides dedicated
              support throughout the booking process.
              {/* Our theaters are suitable for couples, families, and groups. With
              affordable pricing and add-on flexibility, Cine Celebrate is the
              perfect place to celebrate your milestones in a fun, intimate, and
              truly unforgettable way. */}
              <br />
              <br />
              Our theater space is ideal for couples planning a romantic
              evening, families organising a birthday celebration, or groups
              celebrating important milestones. With affordable private theater
              packages in Delhi NCR and flexible options, Cine Celebrate in
              Laxmi Nagar makes it easy to celebrate in a fun, intimate, and
              stress-free way.
              <br />
              <br />
              Every occasion has a story behind it. We simply give it the screen
              it deserves.
              <br />
              <br />
              Cine Celebrate is a registered brand name and trademark owned by Swastik Entertainments.
            </h4>
          </div>
          <div className="about-home-right">
            <img
              class=""
              src={logogif}
              alt="Private theater experience preview"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
        {/* <Wave />
        <WhyUs /> */}
        {/* <section className="h-[200vh] scroll-section bg-[#FFFFFF] flex items-center justify-center">
          <div className="flex flex-col items-center gap-8">
            <h6
              style={{ fontSize: "5rem", paddingTop: "400px" }}
              ref={textRef}
              className="text-[#000000] text-[5rem] font-bold"
            >
              Cine Celebrate
            </h6>
            <div
              ref={videoRef}
              className="w-[480px] h-[165px] rounded-[20px] overflow-hidden"
            >
              <video
                className="w-full h-full object-cover"
                src="https://player.vimeo.com/progressive_redirect/playback/914803778/rendition/1080p/file.mp4?loc=external&amp;log_user=0&amp;signature=5344c0e4fea63ca54bb433621ca0be7b9470b475583fa68b26de2b6e380a390a"
                autoPlay
                muted
                loop
                playsInline
              />
            </div>
          </div>
        </section> */}
        {/* <div className="whyus">
        <h4 data-aos="zoom-in-up" data-aos-duration="2000">
          Why Us
        </h4>
        <h3 data-aos="zoom-in-up" data-aos-duration="2000">
          Why Choose Us ?
        </h3>
        <br />
        <br />
        <Location /> */}
        {/* <div
          className="why-cards"
          data-aos="zoom-in-up"
          data-aos-duration="2000">
          <div className="why-card">
            <img src={img2} />
            <br />
            <p>
              The Cine Celebrate
              <br /> Town Private Theatres <br />
              for Celebrations
            </p>
          </div>
          <div className="why-card">
            <img src={img2} />
            <br />
            <p>
              The Cine Celebrate
              <br /> Town Private Theatres <br />
              for Celebrations
            </p>
          </div>
          <div className="why-card">
            <img src={img2} />
            <br />
            <p>
              The Cine Celebrate
              <br /> Town Private Theatres <br />
              for Celebrations
            </p>
          </div>
        </div> */}
        <section className="findus" aria-labelledby="findus-heading">
          <div className="findus__intro">
            <p data-aos="zoom-in-up" data-aos-duration="2000">
              Find Us
            </p>
            <h2
              id="findus-heading"
              data-aos="zoom-in-up"
              data-aos-duration="2000"
            >
              Find your town and explore our growing celebration network
            </h2>
          </div>

          <div className="find-cards">
            <Link
              className="find-card find-card--active"
              to="/booknow"
              data-aos="zoom-in-up"
              data-aos-duration="2000"
            >
              <span className="find-card__status">Now Booking</span>
              <img src={img3} alt="Delhi branch" />
              <h3>Delhi</h3>
            </Link>

            <div
              className="find-card"
              data-aos="zoom-in-up"
              data-aos-duration="2000"
            >
              <img
                src={coming}
                alt="Coming soon"
                className="find-card__status-image"
              />
              <img src={img4} alt="Mumbai branch coming soon" />
              <h3>Mumbai</h3>
            </div>

            <div
              className="find-card"
              data-aos="zoom-in-up"
              data-aos-duration="2000"
            >
              <img
                src={coming}
                alt="Coming soon"
                className="find-card__status-image"
              />
              <img src={img6} alt="Chennai branch coming soon" />
              <h3>Chennai</h3>
            </div>

            <div
              className="find-card"
              data-aos="zoom-in-up"
              data-aos-duration="2000"
            >
              <img
                src={coming}
                alt="Coming soon"
                className="find-card__status-image"
              />
              <img src={img5} alt="Kolkata branch coming soon" />
              <h3>Kolkata</h3>
            </div>
          </div>
        </section>
        <HowPvt />
        {/* <div className="private-th">
        <div className="private-1">
          <h3>How does<br/> Private Theater<br/> Celebration<br/> work?</h3>
        </div>
        <img src={pri} />
        <div className="private-2">
          <h3>Planning your private theater celebration with The Cine Celebrate is simple and hassle-free. Start by selecting your preferred date and time, then choose from our customizable packages to suit your occasion. Whether it’s a birthday, date night, or anniversary, you can add personalized touches like décor, or even a photoshoot. On the day of your event, enjoy a seamless experience as you watch your favorite movies, shows, photos, or videos on the big screen,Sit back, relax, and let us take care of the details to make your celebration truly unforgettable!</h3>
        </div>
        </div> */}

        {/* <div className="location-import">
          <Location />
        </div> */}

        {/* <OurServices /> */}
        {/* <div className="Services">
        <p data-aos="zoom-in-up" data-aos-duration="2000">
          Services
        </p>
        <h3 data-aos="zoom-in-up" data-aos-duration="2000">
          Our Services
        </h3>
        <br />
        <br />
        <br />
        <div
          className="Services-cards"
          data-aos="zoom-in-up"
          data-aos-duration="2000"
        >
          <div className="Services-card">
            <img src={img7} />
            <h4>Gifts</h4>
          </div>
          <div className="Services-card">
            <img src={img8} />
            <h4>Photoshoot</h4>
          </div>
          <div className="Services-card">
            <img src={img10} />
            <h4>Fog Entry</h4>
          </div>
        </div>
      </div> */}
        {/* <br />
        <br />
        <br />
        <div className="howdoes">
          <div className="howdoes-top">
            <div className="howdoes-left">
              <h3>How does Private Theater Celebration work?</h3>
            </div>
            <div
              className="howdoes-right"
              data-aos="zoom-in"
              data-aos-duration="3000"
            >
              <img src={a} />
            </div>
          </div>
          <br />
          <br />
          <div className="howdoes-top">
            <div className="howdoes-right">
              <img src={aa} data-aos="zoom-in" data-aos-duration="3000" />
            </div>
            <div className="howdoes-left">
              <p>
                Planning your private theater celebration with The Cine Celebrate is
                simple and hassle-free. Start by selecting your preferred date
                and time, then choose from our customizable packages to suit
                your occasion. Whether it’s a birthday, date night, or
                anniversary, you can add personalized touches like décor, or
                even a photoshoot. On the day of your event, enjoy a seamless
                experience as you watch your favorite movies, shows, photos, or
                videos on the big screen,
                complemented by delicious food and beverages. 
                Sit back, relax, and let us take care of the details to make
                your celebration truly unforgettable!
              </p>
              <br />
              <button>Book Now</button>
            </div>
          </div>
        </div> */}
        {/* <br />
        <br />
        <div className="followoninsta">
          <br />
          <br />
          <br />

          <h3>Follow On Instagram</h3>
          <br />
          <br />
          <br />
          <img  src={img11} />
          <br />
          <br />
        </div> */}
        {/* <br/>
        <br/> */}
        {/* <PlayReel />
        <div className="mainimg">
          <NewScroll />
          <NewScroll2 />
        </div> */}
        <CircleImg />

        {/* <ScrollGallery/> */}

        <div className="blog home-news">
          <p>Blog</p>

          <h2>Our News & Events</h2>
          <br />

          <div className="blog-cards">
            {blogs.map((blog, index) => (
              <div
                key={blog.blogId}
                onClick={() => navigate(`/blog/${blog?.slug}`)}
                className="updated-blog-card"
              >
                <div className="updated-blog-card-media">
                  <img
                    src={blog.displayImage}
                    alt={blog.title}
                    className="updated-blog-card-image"
                    loading={index === 0 ? "eager" : "lazy"}
                    decoding="async"
                  />
                  <div className="updated-blog-card-overlay">
                    <p className="updated-blog-card-kicker">
                      {index === 0 ? "Featured story" : "Cine Celebrate journal"}
                    </p>
                    <h3>{blog.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <br />
        {/* <div
                className="blog-card"
                key={blog.blogId}
                onClick={() => navigate(`/blogs/${blog?._id}`)}
              >
                <img src={blog.displayImage} alt={blog.title} />
                <br />

                <div className="text-blog">
                  <h4>{blog.title}</h4>
                </div>
                <br />
              </div> */}
        <HomeFAQ />
        <KeywordFooterSection />
        <Footer />
      </div>
    </>
  );
}

export default Home;
